import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { EssentialService } from '../../services/essential.service';
import { DataSourceService } from '../../shared-components/data-source.service';

@Component({
  selector: 'app-login-client',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginClientComponent implements OnInit {

  @Input() public settings: any;
  @Input() public data: any;

  public view = 'login';
  public site: any;
  public forgetPassword = false;
  public signing = false;
  public routerUrl;
  public error: boolean;
  public loginPlaceHolder = 'Email or Username';

  public loginForm = new FormGroup({
    username: new FormControl('', { validators: Validators.required, updateOn: 'blur' }),
    password: new FormControl('', [Validators.required]),
  });
  public forgetForm = new FormGroup({
    email: new FormControl('', { validators: Validators.required }),
  });
  public signupForm = new FormGroup({
    email: new FormControl('', { validators: Validators.required, updateOn: 'blur' }),
    fullName: new FormControl('', [Validators.required]),
    password: new FormControl('', [Validators.required]),
    confirmPassword: new FormControl('', [Validators.required]),
  });

  public APIData: any = [];
  public externalObj: any;

  constructor(
    private router: Router,
    private sanitizer: DomSanitizer,
    private route: ActivatedRoute,
    private dataSourceService: DataSourceService,
    private essentialsService: EssentialService,
  ) { }

  public ngOnInit() {
    this.site = this.data.moduleService.site;
    this.route.queryParams.subscribe((params) => {
      this.routerUrl = params.returnUrl;
      sessionStorage.setItem('RedirectURL', JSON.stringify(this.routerUrl));
    });

    switch (this.settings.loginType) {
      case 'Email': {
        this.loginPlaceHolder = 'Email';
        break;
      }
      case 'UserName': {
        this.loginPlaceHolder = 'Username';
        break;
      }
      case 'PhoneNumber': {
        this.loginPlaceHolder = 'Phone number';
        break;
      }
      case 'AdditionInfo': {
        this.loginPlaceHolder = this.settings.additionalInfoValue;
        break;
      }
      case 'UsernameOrEmail': {
        this.loginPlaceHolder = 'Username Or Email';
        break;
      }
      case 'UsernameOrPhone': {
        this.loginPlaceHolder = 'Username Or Phone number';
        break;
      }
      case 'PhoneOrEmail': {
        this.loginPlaceHolder = 'Email Or Phone Number';
        break;
      }
      default: {
        this.loginPlaceHolder = 'Email or Username';
        break;
      }

    }
  }

  public RequestPassword(form) {
    this.error = false;
    if (form.invalid) { return; }
    const LoginObj = {
      Email: this.loginForm.controls.username.value,
      Password: this.loginForm.controls.password.value,
      RememberMe: true,
    };
  }

  public login(form) {
    this.error = false;
    if (form.invalid) { return; }
    this.signing = true;
    this.data.authService.loggeIn(this.loginForm.controls.username.value, this.loginForm.controls.password.value
      , this.settings.loginType, this.settings.additionalInfoValue).then((res) => {
        if (res) {
          if (this.settings.redirect && (sessionStorage.getItem('RedirectURL') && sessionStorage.getItem('RedirectURL') !== 'undefined')) {
            location.href = JSON.parse(sessionStorage.getItem('RedirectURL'));

          } else
            if (this.settings.redirect && this.settings.redirectPage) {
              location.href = this.settings.redirectPage;
            } else {
              this.router.navigate(['/']);
              setTimeout(() => { location.reload(); }, 1000);
            }
          if (this.settings.externalAPI) {
            this.getDSData(res);
          }
        } else {
          this.error = true;
          this.signing = false;
        }
      });
  }

  public saveSignup(form) {
    this.error = false;
    if (form.invalid) { return; }
    const signUpObject = {
      Email: this.signupForm.controls.email.value,
      FullName: this.signupForm.controls.fullName.value,
      Password: this.signupForm.controls.password.value,
      ConfirmPassword: this.signupForm.controls.confirmPassword.value,
      RoleId: this.settings.registerRole,
    };
    this.signing = true;
    this.data.authService.register(signUpObject).subscribe((res: any) => {
      const data = {
        customer_id: '',
        //device_token: '',
        name: this.signupForm.controls.fullName.value,
        mobile: '',
        email: this.signupForm.controls.email.value,
      };

      const url = `/ApiInvoker/Invoke/${this.settings.dataSourceId}`;
      this.essentialsService.postData(url, data).subscribe((res) => { console.log(res) });
      this.signing = false;
      if (this.settings.externalAPI) {
        this.getDSData(res);
      }
    }, (error: any) => {
      this.signing = false;
      this.error = true;
      console.log(error);
    });
  }
  public forget(form) {
    this.error = false;
    if (form.invalid) { return; }
    const pathArray = window.location.pathname.split('/');
    let newPathname = '';
    for (let index = 0; index < pathArray.length; index++) {
      const element = pathArray[index];
      if (index === 1) {
        newPathname = element;
      }
    }
    const emailArray = [];
    emailArray.push(this.forgetForm.controls.email.value);
    const requestBody = {
      Email: emailArray[0],
      Host: window.location.origin + '/' + newPathname,
    };
    this.data.authService.forgotPassword(requestBody.Email, requestBody.Host).subscribe((res: any) => {

    }, (error) => {
      this.signing = false;
      this.error = true;
      console.log(error);
    });

  }
  public getBackground(image) {
    return this.sanitizer.bypassSecurityTrustStyle(`url(${image})`);
  }

  public getDSData(dataObj) {
    let data: any;
    this.APIData = [];
    let url;

    if (!Array.isArray(dataObj)) {
      this.externalObj = dataObj;
    } else {
      this.externalObj = dataObj[0];
    }
    data = this.dataSourceService.findInputValues(this.settings.inputParam);
    data.inputType = [];

    for (const p of this.settings.inputParam) {
      if (p.sourceType === 6) {
        const keyExist = data.hasOwnProperty(p.paramName);
        if (keyExist) {
          data[p.paramName] = this.externalObj;
        }
      }
      data.inputType.push(p.paramName);
    }
    if (this.settings.resultPath) {
      url = `/ApiInvoker/Invoke/${this.settings.dataSourceId}/${this.settings.resultPath}`;
    } else {
      url = `/ApiInvoker/Invoke/${this.settings.dataSourceId}`;
    }

    this.essentialsService.postData(url, data).subscribe((res: any) => {
      this.APIData = res ? res : [];
    });
  }

}
